<template>
    <a target="_blank" :href="appStoreLink" @click="clickButton()"><img alt="Download Wotive gym workout tracker app ios app store" src="../../assets/landing-page/appstore.svg" /></a>
</template>

<script>
import { APP_STORE_LINK } from '@/constants';

export default {
  name: "AppleButton",

  computed: {
    appStoreLink() {
      return APP_STORE_LINK;
    },
  },

  methods: {
    clickButton() {
      gtag('event', 'conversion', {'send_to': 'AW-10794836056/EyLACOuKtuoZENjAsJso'});
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

img {
    height: 40px;
    margin-right: 8px;
}
</style>